module.exports = __webpack_public_path__ + "assets/mail.ca408ac3.svg";